export default __webpack_public_path__ + "static/media/frame1c.8b8942ee.PNG";